import { useTheme } from '@emotion/react';
import {
  Box,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import GaugeChart from 'react-gauge-chart';
import { useNavigate } from 'react-router';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCookiesLogin } from '../../config/cookies';
import { tokens } from '../../theme';
import { InformacoesSerasa } from '../SerasaScoreCPF';

const regexCEP = /^(\d{5})(\d{3})$/;
const regexCPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;
const regexPhone = /^(\d{2})(\d{1})?(\d{4})(\d{4})$/;

const HandlerSerasaSocorePj = ({ dataAPI }) => {
  const [officialName, setOfficialName] = useState('');
  const [tradeName, setTradeName] = useState('');
  const [taxIdNumber, setTaxIdNumber] = useState('');
  const [taxRegime, setTaxRegime] = useState('');
  const [legalNature, setLegalNature] = useState({
    Code: '',
    Activity: '',
  });
  const [activities, setActivities] = useState([]);
  const [taxIdStatus, setTaxIdStatus] = useState('');

  const [sizeCompany, setSizeCompany] = useState('');
  const [riskScreening, setRiskScreening] = useState('');
  const [operabilityIndicator, setOperabilityIndicator] = useState('');
  const [taxIdOrigin, setTaxIdOrigin] = useState('SERASA EXPERIAN');

  const [score, setScore] = useState('');
  const [eventProbability, setEventProbability] = useState('');
  const { cookies } = useCookiesLogin();
  const { id, last_company: bussines_id } = cookies.AUTH_TOKEN;
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const navigateToDashboard = () => navigate("/app/dashboard");

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  let basicInfo = dataAPI?.consult?.items?.find((item) => item.code === 'BASIC_INFO');
  let serasaScore = dataAPI?.consult?.items?.find((item) => item.code === 'AGRO_SCORE_CNPJ');
  let serasa = dataAPI?.consult?.items?.find((item) => item.code === 'SERASA');

  console.log(basicInfo, 'basic info finded');

  console.log(serasaScore, 'serasaScore finded');

  console.log(serasa, 'serasa finded');

  // já existe a consulta
  useEffect(() => {
    const basic = basicInfo?.data?.results?.[0];
    const score = serasaScore?.data?.results?.[0];

    if (!basic || !score) return;

    setOfficialName(basic.basicData?.officialName || '');
    setTaxIdNumber(basic.basicData?.taxIdNumber || '');
    setActivities(basic.basicData?.activities || []);
    setTaxRegime(basic.basicData?.taxRegime || '');
    setLegalNature(basic.basicData?.legalNature || {});
    setTaxIdStatus(basic.basicData?.taxIdStatus || '');
    setSizeCompany(basic.basicData?.companySize || '');
    setOperabilityIndicator(basic.basicData?.operabilityIndicator || '');
    setRiskScreening(basic.basicData?.riskScreening || '');

    setScore(score?.score || 0);
    setEventProbability(score?.event_probability || 0);
  }, []);

  return (
    <>
      <ToastContainer />
      <Box
        className=""
        style={{
          marginTop: 50,
        }}
      >
        <Typography variant="h3" color={colors.grey[500]} gutterBottom>
          Dados informativos da empresa.
        </Typography>
        <Grid container spacing={4} marginBottom={3}>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Documento
            </Typography>
            <Typography fontSize={22}>
              {taxIdNumber.replace(regexCNPJ, '$1.$2.$3.$4/$5')}
            </Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Nome
            </Typography>
            <Typography fontSize={22}>{officialName}</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Regime
            </Typography>
            <Typography fontSize={22}>{taxRegime}</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Origem Dados
            </Typography>
            <Typography fontSize={22}>{taxIdOrigin}</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              CNAES
            </Typography>
            <Typography fontSize={22}>Atividade {legalNature.Activity}</Typography>
            <Typography fontSize={22}>Código {legalNature.Code}</Typography>
          </Grid>
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Triagem de Risco
            </Typography>
            {/* <Typography fontSize={16} color={colors.grey[500]}>
              Detecção precoce de danos ao cliente para prestação de cuidados
              seguros, eficazes e adequados.
            </Typography> */}
            <Typography fontSize={22}>{riskScreening}</Typography>
          </Grid>
          {/* <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Indicador de operabildade
            </Typography>
            <Typography fontSize={16} color={colors.grey[500]}>
              Indicadores de retardo incluem taxa de disponibilidade e tempo de
              restauração, indicadores antecipados incluem frequência de dias de
              caos e tempo de resposta a incidentes
            </Typography>

            <Typography fontSize={22}>{operabilityIndicator}</Typography>
          </Grid> */}
          <Grid item xs={12} md={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Porte da empresa
            </Typography>
            <Typography fontSize={22}>{sizeCompany}</Typography>
          </Grid>
        </Grid>
        {activities.length != 0 ? (
          <Grid sx={{ marginY: 3 }} grid-xs-7>
            <Typography variant="h3" color={colors.grey[500]} gutterBottom>
              Atividades CNPJ.
            </Typography>
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontSize: 18 }}>Código</TableCell>
                    <TableCell sx={{ fontSize: 18 }}>Atividade</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {activities.map((data) => (
                    <TableRow>
                      <TableCell sx={{ fontSize: 16 }}>{data.Code}</TableCell>
                      <TableCell sx={{ fontSize: 16 }}>{data.Activity}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        ) : null}
        {/* Endereços */}
        {basicInfo?.results?.[0]?.addresses?.length > 0 && (
          <Typography variant="h4" color={colors.grey[500]} marginTop={3}>
            Endereços
          </Typography>
        )}
        {basicInfo?.results?.[0]?.addresses?.length > 0 && (
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: 16 }}>Tipo</TableCell>
                  <TableCell sx={{ fontSize: 16 }}>Logradouro</TableCell>
                  <TableCell sx={{ fontSize: 16 }}>Número</TableCell>
                  <TableCell sx={{ fontSize: 16 }}>Cidade</TableCell>
                  <TableCell sx={{ fontSize: 16 }}>UF</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {basicInfo?.results?.[0]?.addresses?.map((address, index) => (
                  <TableRow key={index}>
                    <TableCell>{address.type || 'N/A'}</TableCell>
                    <TableCell>{address.addressMain || 'N/A'}</TableCell>
                    <TableCell>{address.number || 'S/N'}</TableCell>
                    <TableCell>{address.city || 'N/A'}</TableCell>
                    <TableCell>{address.uf || 'N/A'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>
      <div
        className=""
        style={{
          marginTop: 30,
        }}
      >
        <Typography variant="h3" color={colors.grey[500]} gutterBottom>
          Informações para análise de crédito
        </Typography>
        <Grid container spacing={4} marginBottom={3} marginTop={3}>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Agro Score
            </Typography>
            <Typography
              color={score < 301 ? '#ff5050' : score < 701 ? '#ed6c02' : 'secondary'}
              fontSize={22}
            >
              {score} de 1000
            </Typography>

            <GaugeChart
              id="gauge-chart2"
              nrOfLevels={20}
              percent={score ? Number(score) / 1000 : 0}
              textColor={colors.grey[700]}
              arcWidth={0.2}
              colors={['#FF0000', '#00FF00']}
              formatTextValue={(value) => score}
              style={{
                fontWeight: 600,
              }}
            />
          </Grid>
          <Grid item xs={4} sx={{ marginY: 3 }}>
            <Typography variant="h4" color={colors.grey[300]} marginBottom={2}>
              Propabilidade de Inadimplência
            </Typography>
            <Typography fontSize={22}>{parseFloat(eventProbability * 100).toFixed(2)} %</Typography>
          </Grid>
        </Grid>
        <ScoreDescription />

        {/* SERASA Section */}
        {serasa ? <InformacoesSerasa serasaData={serasa}></InformacoesSerasa> : <></>}
      </div>
    </>
  );
};

export const ScoreDescription = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box sx={{ flexGrow: 1 }}>
      {/* Imagem do Serasa Experian */}
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 3 }}></Box>
      <Typography
        variant="h4"
        align="left"
        gutterBottom
        color={colors.greenAccent['500']}
        sx={{ fontSize: '2rem' }}
      >
        Entenda o Agro Score
      </Typography>
      <Typography
        variant="h4"
        align="left"
        color="textSecondary"
        paragraph
        sx={{ fontSize: '1.25rem' }}
      >
        O Agro Score é uma pontuação que vai de 0 a 1000 e reflete a probabilidade de um consumidor
        pagar suas contas em dia.
      </Typography>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        {/* Quadradinho Vermelho */}
        {/* <Grid item xs={12} sm={1}>
          <Box
            sx={{
              width: 24,
              height: 24,
              backgroundColor: "error.main",
              margin: "0 auto",
              borderRadius: 1,
            }}
          />
        </Grid> */}

        <Grid item xs={12} sm={3}>
          <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: '1.5rem' }}>
              Score baixo
            </Typography>
            <Typography variant="h4" color="error" gutterBottom sx={{ fontSize: '2rem' }}>
              0 a 300
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '1.1rem' }}>
              Alto risco de inadimplência. Dificuldade em conseguir crédito.
            </Typography>
          </Paper>
        </Grid>

        {/* Quadradinho Amarelo */}
        {/* <Grid item xs={12} sm={1}>
          <Box
            sx={{
              width: 24,
              height: 24,
              backgroundColor: "warning.main",
              margin: "0 auto",
              borderRadius: 1,
            }}
          />
        </Grid> */}

        <Grid item xs={12} sm={3}>
          <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: '1.5rem' }}>
              Score médio
            </Typography>
            <Typography variant="h4" color="warning.main" gutterBottom sx={{ fontSize: '2rem' }}>
              301 a 700
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '1.1rem' }}>
              Risco moderado. Chance razoável de conseguir crédito, mas com condições restritas.
            </Typography>
          </Paper>
        </Grid>

        {/* Quadradinho Verde */}
        {/* <Grid item xs={12} sm={1}>
          <Box
            sx={{
              width: 24,
              height: 24,
              backgroundColor: "success.main",
              margin: "0 auto",
              borderRadius: 1,
            }}
          />
        </Grid> */}

        <Grid item xs={12} sm={3}>
          <Paper elevation={3} sx={{ padding: 2, textAlign: 'center' }}>
            <Typography variant="h6" gutterBottom sx={{ fontSize: '1.5rem' }}>
              Score alto
            </Typography>
            <Typography variant="h4" color="success.main" gutterBottom sx={{ fontSize: '2rem' }}>
              701 a 1000
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ fontSize: '1.1rem' }}>
              Baixo risco de inadimplência. Facilidade em obter crédito com boas condições.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        paragraph
        sx={{ marginTop: 3, fontSize: '1.25rem' }}
      >
        Score de crédito AGRO, focado nas movimentações e segmento do agronegócio, utilizando o
        Serasa Experian como fonte de dados.
      </Typography>
    </Box>
  );
};
export default HandlerSerasaSocorePj;
